import React from "react";

const ArrowIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    style={{ width: "40px", height: "40px", aspectRatio: "1/1" }}
    {...props}
  >
    <g clipPath="url(#clip0_5804_1248)">
      <path d="M26.6832 18.3333H6.6665V21.6666H26.6832V26.6666L33.3332 19.9999L26.6832 13.3333V18.3333Z" fill="var(--theme-palette-common-white)" />
    </g>
    <defs>
      <clipPath id="clip0_5804_1248">
        <rect width="40" height="40" fill="var(--theme-palette-common-white)" />
      </clipPath>
    </defs>
  </svg>
);

export default ArrowIcon;
